import { checkIsAfterOrEqualDate } from 'aa_common/front-end'

import {
  MAX_WARNING_UNIT_ACQUISITION_COST,
  MIN_WARNING_UNIT_ACQUISITION_COST,
  START_USAGE_THRESHOLD_DATE,
} from './const'

/**
 * The 300,000 ceiling only applies once the asset is in service on/before the rule date.
 * While the usage-started date is blank we can only check preventively, so the 400,000
 * ceiling applies whatever the acquired/transition date is.
 */
export const getSmallAmountAssetUnitCostLimit = (usageStartedAt?: string) => {
  return !usageStartedAt || checkIsAfterOrEqualDate(usageStartedAt, START_USAGE_THRESHOLD_DATE)
    ? MAX_WARNING_UNIT_ACQUISITION_COST
    : MIN_WARNING_UNIT_ACQUISITION_COST
}

export const isSmallAmountAssetAcquisitionCostValid = (
  limit: number,
  // `net_acquisition_cost` reaches us as a string on some payloads, so accept both.
  acquisitionCost?: number | string,
  quantity?: number
) => {
  // Can only validate when we know the acquisition cost.
  if (acquisitionCost === undefined || acquisitionCost === null) {
    return true
  }
  // A quantity of 0 (or blank) is treated as 1.
  const divisor = quantity && quantity > 0 ? quantity : 1

  return Number(acquisitionCost) / divisor < limit
}
